var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ loading: _vm.loading },attrs:{"id":"loading"}},[_c('div',[_c('img',{attrs:{"src":"/images/loading.png"}}),_c('p',[_vm._v(_vm._s(_vm.loadingText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }